exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo[data-v-1818c948] {\r\n  display: inline-block;\r\n  width: 600px;\r\n  height: 338px;\r\n  text-align: center;\r\n  line-height: 100px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  position: relative;\r\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\r\n          box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\r\n  margin-right: 4px;\n}\n.demo[data-v-1818c948]:hover {\r\n  display: block;\n}\r\n", ""]);

// exports
